import { render, staticRenderFns } from "./InteriorPollution.vue?vue&type=template&id=e9bd0478&scoped=true&"
import script from "./InteriorPollution.vue?vue&type=script&lang=js&"
export * from "./InteriorPollution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9bd0478",
  null
  
)

export default component.exports